<template>
  <div class="serverErrorPage">
    <div class="background"></div>
    <div class="messageBox">
      <div class="messages">
        <h1>{{ t("title") }}</h1>
        <h4>{{ t("message") }}</h4>
      </div>
      <img class="serverErrorImage" src="@/assets/pageNotFound.png" alt="Server Error">
    </div>
  </div>
</template> 


<script>
import { useI18n } from "vue-i18n";

export default {
  setup() {
    const { t } = useI18n({
      inheritLocale: true,
      useScope: "local"
    });
    return { t };
  },

  methods: {
    goToCourses() {
      this.$router.replace({ name: "courses" });
    }
  }
};
</script>


<i18n>
{
  "en-GB": {
    "title": "Server Error",
    "message": "Something went wrong, we are working on a fix!"
    },
  "nl-NL": {
    "title": "Serverfout",
    "message": "Er ging iets mis, we werken aan een oplossing!"
  }
}

</i18n>

<style scoped>
.serverErrorPage {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
}

.background {
  background-image: url("https://phoenix-engineering.be/wp-content/uploads/2019/07/shutterstock_1113165392.png");
  background-size: cover;
  background-position: unset;
  background-repeat: no-repeat;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  filter: blur(3px);
  -webkit-filter: blur(3px);
  z-index: -1;
}
.messageBox {
  display: flex;
  margin: auto;

  background-color: rgba(221, 221, 221, 0.92);
  box-shadow: 0 32px 64px rgba(235, 235, 235, 0.267);
}
.messages {
  margin: 100px;
}
.serverErrorImage {
  width: 250px;
  height: 217px;
  margin: 40px;
}

@media screen and (max-width: 1200px) {
  .messageBox {
    align-items: center;
    justify-content: center;
  }
  .messages {
    margin: 60px;
    margin-bottom: 60px;
  }
  .serverErrorImage {
    width: 180px;
    height: 156px;
    margin: 60px;
  }
}
@media screen and (max-width: 950px) {
  .messageBox {
    flex-direction: column;
    width: 400px;
    height: 500px;
  }
  .messages {
    margin: 60px;
    margin-bottom: 60px;
  }
  .serverErrorImage {
    width: 180px;
    height: 156px;
    margin: 60px;
    margin-top: 0px;
  }
}
@media screen and (max-width: 500px) {
  .messageBox {
    flex-direction: column;
    width: 95vw;
    height: 95vh;
  }
  .messages {
    margin: 20px;
    margin-bottom: 50px;
  }
  .serverErrorImage {
    width: 160px;
    height: 140px;
    margin: 30px;
  }
  h1 {
    font-size: 26px;
  }
  h4 {
    font-size: 16px;
    width: 250px;
  }
}
@media screen and (max-width: 500px) {
  .messageBox {
    flex-direction: column;
    width: 95vw;
    height: 95vh;
  }
  .messages {
    margin: 20px;
    margin-bottom: 50px;
  }
  .serverErrorImage {
    width: 160px;
    height: 140px;
    margin: 30px;
  }
  h1 {
    font-size: 26px;
  }
  h4 {
    font-size: 16px;
    width: 250px;
  }
}
@media screen and (max-width: 300px) {
  h1 {
    font-size: 24px;
  }
  h4 {
    font-size: 13px;
    width: 220px;
  }
  .messages {
    margin: 20px;
    margin-bottom: 20px;
  }
  .serverErrorImage {
    width: 145px;
    height: 125px;
    margin: 30px;
  }
}
</style>